import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M13 19l-1 1l-7.5 -7.428a5 5 0 1 1 7.5 -6.566a5 5 0 0 1 8.003 5.997","key":"svg-0"}],["path",{"d":"M19 16l-2 3h4l-2 3","key":"svg-1"}]]

/**
 * IconHeartBolt
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItaGVhcnQtYm9sdCIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNMTMgMTlsLTEgMWwtNy41IC03LjQyOGE1IDUgMCAxIDEgNy41IC02LjU2NmE1IDUgMCAwIDEgOC4wMDMgNS45OTciIC8+CiAgPHBhdGggZD0iTTE5IDE2bC0yIDNoNGwtMiAzIiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/heart-bolt
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconHeartBolt = createReactComponent('outline', 'heart-bolt', 'HeartBolt', __iconNode);

export default IconHeartBolt;